import { DeleteFilled } from '@ant-design/icons'
import { EbolStatusTag } from '@components/OrderMovements/OrderMovements/EbolMatching/EbolStatusTag'
import { GraviButton } from '@gravitate-js/excalibrr'
import { Col, Form, Input, Popconfirm, Popover, Row, Select } from 'antd'
import { BOLHeaderDisplay } from './BOLHeaderDisplay'
import { TimezoneDateTimePicker } from '@/components/_SiteWide/TimezoneDateTimePicker'

type BOLHeaderFormProps = {
  bol: Gravitate.BolObject
  editing: boolean
  index: number
  canEditBOLs: boolean
  terminals: string[]
  removeBOL: () => void
  stores?: Gravitate.Site[]
  attendantNote?: string
  fields: string[]
  handleOpenImageModal: () => void
  orderId?: number
  timezone: string
}

const { Option } = Select
export function BOLHeaderForm({
  bol,
  editing,
  index,
  canEditBOLs,
  terminals,
  removeBOL,
  stores,
  attendantNote,
  fields,
  handleOpenImageModal,
  orderId,
  timezone,
}: BOLHeaderFormProps) {
  const canDelete = fields.length > 1

  if (!editing) {
    return (
      <BOLHeaderDisplay
        bol={bol}
        attendantNote={attendantNote}
        handleOpenImageModal={handleOpenImageModal}
        orderId={orderId}
        timezone={timezone}
      />
    )
  }
  return (
    <Row className='p-3 bol-header-row' align='middle'>
      <Col span={5}>
        <Row>
          <EbolStatusTag ebol_status={bol?.ebol_status} orderId={orderId} bolId={bol?.key} />
          <Form.Item name={[index, 'number']} rules={[{ required: true, message: 'BOL # is required' }]}>
            <Input placeholder='BOL #' style={{ width: '80%' }} />
          </Form.Item>
        </Row>
      </Col>
      <Col span={3}>
        <Form.Item name={[index, 'type']} rules={[{ required: true, message: 'Type is Required' }]}>
          <Select allowClear showSearch style={{ width: '80%' }} placeholder='BOL Type'>
            <Option value='load'>Load</Option>
            <Option value='drop'>Drop</Option>
          </Select>
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item name={[index, 'location']} rules={[{ required: true, message: 'Terminal is Required' }]}>
          <Select allowClear showSearch style={{ width: '80%' }} placeholder='BOL Terminal'>
            {terminals?.map((t, i) => (
              <Option key={i} value={t}>
                {t}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
      <Col align='left' span={3}>
        <Form.Item name={[index, 'date']} rules={[{ required: true, message: 'BOL Date is Required' }]}>
          <TimezoneDateTimePicker picker='date' placeholder='BOL Date' timezone={timezone} />
        </Form.Item>
      </Col>
      <Col align='left' span={3}>
        <Form.Item name={[index, 'time']} rules={[{ required: true, message: 'BOL Time is Required' }]}>
          <TimezoneDateTimePicker picker='time' placeholder='BOL Time' timezone={timezone} />
        </Form.Item>
      </Col>
      <Col align='left' span={3}>
        <Form.Item name={[index, 'site']} rules={[{ required: false }]}>
          <Select allowClear showSearch style={{ width: '80%' }} placeholder='BOL Site'>
            {stores?.map((t, i) => (
              <Option key={i} value={t.store_number}>
                {t.store_number}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
      {canEditBOLs && (
        <Col className='flex justify-end items-center' flex={1} align='right'>
          <Popconfirm title='Sure you want to delete this BOL?' onConfirm={removeBOL} placement='left'>
            {canDelete ? (
              <GraviButton icon={<DeleteFilled />} buttonText='Delete BOL' error className='ml-3' />
            ) : (
              <Popover content='You cannot delete the last BOL on an order' placement='bottomRight'>
                <div>
                  <GraviButton icon={<DeleteFilled />} buttonText='Delete BOL' error className='ml-3' disabled />
                </div>
              </Popover>
            )}
          </Popconfirm>
        </Col>
      )}
    </Row>
  )
}
